import { useState } from 'react';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
// @mui
import {
  Stack,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useResponsive from '../../hooks/useResponsive';
import useAuth from '../../hooks/useAuth';
// components
import Iconify from '../../components/Iconify';
// routes
import { PATH_SETTINGS } from '../../routes/paths';
// utils
import axios from '../../utils/axios';

export default function MatchingOnDialog({ isOpen, closeDialog }) {
  const { getUser } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const smUp = useResponsive('up', 'sm');
  const [isTurnOn, setIsTurnOn] = useState(false);
  const router = useRouter();

  const turnOn = async () => {
    try {
      setIsTurnOn(true);
      await axios.post(`/api/crews/settings/match-on/`);
      enqueueSnackbar(`매칭 제안 받기가 활성화 되었습니다.`);
      getUser();
      setIsTurnOn(false);
      closeDialog();
      router.push({pathname: PATH_SETTINGS.root, query: {tab: 'noti'}});
    } catch (err) {
      setIsTurnOn(false);
      console.error(err);
    }
  };

  return (
    <Dialog open={isOpen} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 20, height: 20, color: 'error.main' }} />
          <Typography variant="subtitle2" sx={{ color: "error.main" }}>
            잠깐, 꼭 확인해주세요
          </Typography>
        </Stack>
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          매칭 제안을 켤까요?
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
          지금은 매칭 알림이 꺼져있어요. <br />
          매칭 알림을 켜야 사이드잡 제안을 받을 수 있어요.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column-reverse', sm: 'row' }} spacing={1} sx={{ width: '100%' }} justifyContent="flex-end">
          <LoadingButton
            loading={isTurnOn}
            onClick={closeDialog}
            size="large"
            sx={{ px: 6 }}
            fullWidth={!smUp}
          >
            닫기
          </LoadingButton>
          <LoadingButton
            loading={isTurnOn}
            variant="contained"
            onClick={turnOn}
            size="large"
            sx={{ px: 6 }}
            fullWidth={!smUp}
          >
            매칭 제안 켜기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
};
